import styled from 'styled-components';
import dynamic from 'next/dynamic';
import GridContainer from '@ertelecom/ui-react/components/layouts/gridContainer';
import { FONTS } from '@ertelecom/ui-react/assets/js/constants';

const Menu = dynamic(() => import('~/src/components/Menu'));
const QuizBlock = dynamic(() => import('~/src/components/QuizBlock'));

export const HeadContainer = styled(GridContainer)`
    margin-bottom: 30px;
    @media (max-width: 859px) {
        margin-top: 50px;
    }
`;

export const Quiz = styled(QuizBlock)`
    margin-top: 40px;
`;

export const Wrapper = styled.div`
    display: block;
    width: 100%;
    overflow: hidden;
    @media screen and (max-width: 859px) {
        padding-top: ${({ isAuth }) => isAuth ? '50px' : '0'};
    }
`;

export const BannerSection = styled.div`
    display: block;
    margin-top: 70px;
    width: 100%;
    @media (max-width: 860px) {
        margin-top: 90px;
    }
`;

export const BundlesTitle = styled.h1`
    margin: 30px 0 0;
    ${FONTS.H2};
    color: #000000;
    width: 100%;

    @media (max-width: 530px) {
        ${FONTS.H3};
    }
`;

export const BundlesSubtitle = styled.span`
    display:inline-block;
    width: 100%;
    ${FONTS.XXL};
    margin-top: 10px;
`;

export const TariffMenu = styled(Menu)`
  margin-bottom: 0;
`;
